// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
.web-page-header {
  display: flex;
  justify-content: space-between;
  padding: 37px 100px 10px 50px;
  background-color: #150924;
  align-items: center;
  border-bottom: 1px solid #dcd5e54a;
}

.web-page-header .logo img {
  width: 92px;
}

.web-page-header .nav {
  display: flex;
  align-items: center;
}

.web-page-header .nav-links {
  display: flex;
  list-style: none;
  margin-bottom: 0px;
}

.web-page-header .nav-links li {
  margin-right: 24px;
  opacity: 0.5;
}

.web-page-header .nav-links li a {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-decoration: none;
}

.web-page-header .nav-links li.active {
  opacity: 1;
  position: relative;
  color: white;
}

.web-page-header .nav-links li.active::after {
  content: "";
  position: absolute;
  height: 4px;
  width: 100%;
  background-color: #9256e8;
  border-radius: 5px 5px 0px 0px;
  bottom: -23px;
  left: 0;
}

.web-page-header .nav-links li a:hover {
  text-decoration: none !important;
}

.web-page-header .auth-buttons {
  display: flex;
}

.web-page-header .auth-buttons button {
  border: none;
  cursor: pointer;
}

.web-page-header .auth-buttons button a {
  color: #242424 !important;
  text-decoration: none !important;
}

.web-page-header .auth-buttons button a:hover {
  text-decoration: none !important;
}

.web-page-header .signup {
  background: #06efc5;
  color: #242424;
  text-align: center;
  font-size: 18.333px;
  font-style: normal;
  font-weight: 800;
  line-height: 13.333px;
  padding: 18px 29.5px;
}

.web-page-header .login {
  background: #06efc5;
  color: #242424;
  text-align: center;
  font-size: 18.333px;
  font-style: normal;
  font-weight: 800;
  line-height: 13.333px;
  padding: 18px 29.5px;
  margin-right: 22px;
}

/* Mobile styles */
@media (max-width: 850px) {
  .web-page-header {
    padding: 20px;
  }

  .web-page-header .nav {
    display: none;
    flex-direction: column;
    width: 100%;
    background-color: #150924;
    position: absolute;
    top: 70px;
    left: 0;
    text-align: center;
  }

  .web-page-header .nav.open {
    display: flex;
    z-index: 2;
    background-color: #150924;
  }

  .web-page-header .nav-links {
    flex-direction: column;
    width: 100%;
  }

  .web-page-header .nav-links li {
    margin: 10px 0;
    text-align: left;
    padding-left: 20px;
  }

  .web-page-header .nav-links li a {
    color: white;
    font-size: 16px;
    opacity: 1;
  }

  .web-page-header .auth-buttons {
    margin-top: 20px;
    width: 100%;
    background-color: #150924;
    padding-left: 20px;
    padding-bottom: 50px;
  }

  .web-page-header .auth-buttons button {
    margin-bottom: 10px;
    color: white;
  }

  .web-page-header .menu-icon {
    display: block;
    cursor: pointer;
  }

  .web-page-header .menu-icon img {
    width: 30px;
  }
}

@media (max-width: 1200px) {
  .web-page-header .nav-links li {
    margin-right: 10px;
  }

  .web-page-header .login {
    padding: 18px 12px;
  }

  .web-page-header .signup {
    padding: 18px 12px;
  }
}

@media (max-width: 1024px) {
  .web-page-header {
    padding: 30px 20px;
    padding-bottom: 11px;
  }
}

@media (min-width: 850px) {
  .web-page-header .menu-icon {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,OAAO;AACT;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* General styles */\n.web-page-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 37px 100px 10px 50px;\n  background-color: #150924;\n  align-items: center;\n  border-bottom: 1px solid #dcd5e54a;\n}\n\n.web-page-header .logo img {\n  width: 92px;\n}\n\n.web-page-header .nav {\n  display: flex;\n  align-items: center;\n}\n\n.web-page-header .nav-links {\n  display: flex;\n  list-style: none;\n  margin-bottom: 0px;\n}\n\n.web-page-header .nav-links li {\n  margin-right: 24px;\n  opacity: 0.5;\n}\n\n.web-page-header .nav-links li a {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n  text-decoration: none;\n}\n\n.web-page-header .nav-links li.active {\n  opacity: 1;\n  position: relative;\n  color: white;\n}\n\n.web-page-header .nav-links li.active::after {\n  content: \"\";\n  position: absolute;\n  height: 4px;\n  width: 100%;\n  background-color: #9256e8;\n  border-radius: 5px 5px 0px 0px;\n  bottom: -23px;\n  left: 0;\n}\n\n.web-page-header .nav-links li a:hover {\n  text-decoration: none !important;\n}\n\n.web-page-header .auth-buttons {\n  display: flex;\n}\n\n.web-page-header .auth-buttons button {\n  border: none;\n  cursor: pointer;\n}\n\n.web-page-header .auth-buttons button a {\n  color: #242424 !important;\n  text-decoration: none !important;\n}\n\n.web-page-header .auth-buttons button a:hover {\n  text-decoration: none !important;\n}\n\n.web-page-header .signup {\n  background: #06efc5;\n  color: #242424;\n  text-align: center;\n  font-size: 18.333px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 13.333px;\n  padding: 18px 29.5px;\n}\n\n.web-page-header .login {\n  background: #06efc5;\n  color: #242424;\n  text-align: center;\n  font-size: 18.333px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 13.333px;\n  padding: 18px 29.5px;\n  margin-right: 22px;\n}\n\n/* Mobile styles */\n@media (max-width: 850px) {\n  .web-page-header {\n    padding: 20px;\n  }\n\n  .web-page-header .nav {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    background-color: #150924;\n    position: absolute;\n    top: 70px;\n    left: 0;\n    text-align: center;\n  }\n\n  .web-page-header .nav.open {\n    display: flex;\n    z-index: 2;\n    background-color: #150924;\n  }\n\n  .web-page-header .nav-links {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .web-page-header .nav-links li {\n    margin: 10px 0;\n    text-align: left;\n    padding-left: 20px;\n  }\n\n  .web-page-header .nav-links li a {\n    color: white;\n    font-size: 16px;\n    opacity: 1;\n  }\n\n  .web-page-header .auth-buttons {\n    margin-top: 20px;\n    width: 100%;\n    background-color: #150924;\n    padding-left: 20px;\n    padding-bottom: 50px;\n  }\n\n  .web-page-header .auth-buttons button {\n    margin-bottom: 10px;\n    color: white;\n  }\n\n  .web-page-header .menu-icon {\n    display: block;\n    cursor: pointer;\n  }\n\n  .web-page-header .menu-icon img {\n    width: 30px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .web-page-header .nav-links li {\n    margin-right: 10px;\n  }\n\n  .web-page-header .login {\n    padding: 18px 12px;\n  }\n\n  .web-page-header .signup {\n    padding: 18px 12px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .web-page-header {\n    padding: 30px 20px;\n    padding-bottom: 11px;\n  }\n}\n\n@media (min-width: 850px) {\n  .web-page-header .menu-icon {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
